<vnm-checkout-booking-cart-item *ngFor="let item of items$ | async" [item]="item"></vnm-checkout-booking-cart-item>
